import { c as _c } from "react/compiler-runtime";
import './nav-sheet.scss';
import { Badge } from '@sola/ark-core/atoms/badge/badge.tsx';
import { NavLink } from '@sola/ark-core/atoms/link/nav-link.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { FlexibleContentProps, NavigationProps } from '@sola/schema/lib/schema.ts';
import { Dialpad } from '../../atoms/dialpad/dialpad.tsx';
import { LinkList } from '../../atoms/link-list/link-list.tsx';
import { NavCard } from '../nav-card/index.ts';
type NavSheetProps = {
  items: NavigationProps[];
  cta?: FlexibleContentProps;
};
type TitleElementProps = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  useLink?: boolean;
};
const TitleElement = t0 => {
  const $ = _c(8);
  const {
    children,
    className,
    href,
    target,
    useLink
  } = t0;
  if (useLink) {
    const t1 = href || "#";
    let t2;
    if ($[0] !== children || $[1] !== className || $[2] !== t1 || $[3] !== target) {
      t2 = <NavLink href={t1} target={target} className={className}>{children}</NavLink>;
      $[0] = children;
      $[1] = className;
      $[2] = t1;
      $[3] = target;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t1;
  if ($[5] !== children || $[6] !== className) {
    t1 = <div className={className}>{children}</div>;
    $[5] = children;
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};
export const NavSheet: React.FC<NavSheetProps> = t0 => {
  const $ = _c(11);
  const {
    items,
    cta
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== items) {
    const columnHasIcon = items.some(_temp);
    t1 = items.map(_temp2).join();
    t2 = "NavSheet__parent-container flex flex-col gap-comfy-sm";
    t3 = items.map(item => {
      const titleHasLink = Boolean(item.link);
      return <div className="flex flex-col" key={item.title}><TitleElement useLink={titleHasLink} href={item?.link} target={item?.target} className={cn("label-neutral flex flex-col py-snug-xl px-comfy-xs", {
          NavSheet__link: titleHasLink
        })}><div className="flex gap-comfy-xs">{item?.icon && <ArkIcon iconName={item?.icon} className="NavSheet__icon" />}<div className={cn("flex flex-col", {
              "NavSheet__title--padded": columnHasIcon && !item?.icon,
              "gap-snug-md": item.description
            })}><div className="flex gap-snug-xl items-center"><span className="NavSheet__text label label-neutral label-lg label-potent">{item.title}</span>{item.badge?.text && <Badge label={item.badge?.text} color={item.badge?.color} size="sm" />}</div><p className="NavSheet__description label-md label-moderate">{item.description}</p></div></div></TitleElement><div className={cn({
          "NavSheet__grid-container mt-snug-md": item.displayVariant === "grid"
        })}>{Boolean(item?.items?.length) && (item.displayVariant === "grid" ? <Dialpad item={item} /> : <LinkList item={item} useHover={true} usePadding={true} />)}</div></div>;
    });
    $[0] = items;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== cta) {
    t4 = cta && <NavCard {...cta} />;
    $[4] = cta;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <div key={t1} className={t2}>{t3}{t4}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
function _temp(i) {
  return Boolean(i.icon);
}
function _temp2(i_0) {
  return i_0.title;
}